<template>
  <div class="flex flex-row items-center gap-4">
    <el-date-picker
      class="flex-1"
      v-model="startProxy"
      type="date"
      :placeholder="startPlaceholder"
      :format="format"
      :value-format="valueFormat"
      :clearable="clearable"
    />
    <div>To</div>
    <el-date-picker
      class="flex-1"
      v-model="endProxy"
      type="date"
      :placeholder="endPlaceholder"
      :format="format"
      :value-format="valueFormat"
      :clearable="clearable"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);
export default {
  name: "SmartDatePicker",
  emits: ["update:startDate", "update:endDate"],
  props: {
    startDate: {
      type: [String, Date],
      default: null,
    },
    endDate: {
      type: [String, Date],
      default: null,
    },
    startPlaceholder: {
      type: String,
      default: "Start date",
    },
    endPlaceholder: {
      type: String,
      default: "End date",
    },
    format: {
      type: String,
      default: "yyyy-MM-dd",
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    startProxy: {
      get() {
        if (
          typeof this.startDate === "string" &&
          /^\d{4}-\d{2}-\d{2}/.test(this.startDate)
        ) {
          const matchStr = this.startDate.match(/^(\d{4}-\d{2}-\d{2}).*/);
          return matchStr ? matchStr[1] : null;
        }
        return null;
      },
      set(val) {
        this.$emit(
          "update:startDate",
          val === null ? null : `${val}T00:00:00Z`
        );
      },
    },
    endProxy: {
      get() {
        if (
          typeof this.endDate === "string" &&
          /^\d{4}-\d{2}-\d{2}/.test(this.endDate)
        ) {
          const matchStr = this.endDate.match(/^(\d{4}-\d{2}-\d{2}).*/);
          return matchStr ? matchStr[1]: null;
        }
        return null;
      },
      set(val) {
        this.$emit("update:endDate", val === null ? null : `${val}T23:59:59Z`);
      },
    },
  },
};
</script>
